import { orderBy } from 'lodash-es'

import type { CustomerRoutedCarrierDTO, Workflow } from '@fv/models'

import { useStaticDataQuery } from '@/hooks/useStaticDataQuery'
import { shipperFetch } from '@/utils/shipperFetch'

type CustomerRoutedDTO = {
  carriers: CustomerRoutedCarrierDTO[]
}

async function fetchCustomerRoutedCarriers(
  workflow: Workflow,
): Promise<CustomerRoutedDTO> {
  const result = await shipperFetch<CustomerRoutedDTO>(
    `/carriers/customer-routed?workflow=${workflow}&v=2`,
  )
  return {
    carriers: orderBy(result.carriers, c => c.name?.toLowerCase()),
  }
}

export function useCustomerRoutedCarriers(workflow: Workflow) {
  return useStaticDataQuery(['customer-routed-carriers', workflow], () =>
    fetchCustomerRoutedCarriers(workflow),
  )
}
